import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles, withTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Media from "./Media";

const styles = theme => ({
  // root: {
  //   display: "flex",
  //   alignItems: "center"
  // },
  avatar: {
    width: "51px",
    height: "51px",
    margin: 4,
    fontSize: "3vh",
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.common.white,
    border: "5px solid " + theme.palette.primary.dark
  },
  activeAvatar: {
    width: "51px",
    height: "51px",
    margin: 4,
    fontSize: "3vh",
    color: theme.palette.primary.light,
    backgroundColor: theme.palette.grey[200],
    border: "5px solid " + theme.palette.primary.light
  },
  activeContentAvatar: {
    width: "51px",
    height: "51px",
    margin: 4,
    fontSize: "3vh",
    color: theme.palette.common.black,
    backgroundColor: theme.palette.primary.light,
    border: "5px solid " + theme.palette.common.black
  },
  playButton: {
    margin: 4
  }
});

function Content(props) {
  const { content, classes } = props;
  return (
    <div className={classes.playButton}>
      <Media {...content[0]} />
    </div>
  );
}

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  content: PropTypes.array.isRequired
};

class BikeNode extends Component {
  render() {
    const {
      classes,
      number,
      active,
      // current,
      // callback,
      content
      // navigationStarted
    } = this.props;
    // let activeClass = classes.avatar;
    // if (active) {
    //   activeClass = classes.activeAvatar;
    // }

    return (
      <div className={classes.root}>
        {content ? (
          active ? (
            // <Avatar key={number} className={classes.activeContentAvatar}>
            //   {number}CA
            // </Avatar>
            <Content classes={classes} content={content} />
          ) : (
            <Avatar key={number} className={classes.activeContentAvatar}>
              {number}
            </Avatar>
            // <Content classes={classes} content={content} />
          )
        ) : active ? (
          <Avatar key={number} className={classes.activeAvatar}>
            {number}
          </Avatar>
        ) : (
          <Avatar key={number} className={classes.avatar}>
            {number}
          </Avatar>
        )}
        {/* {active && content ? (
          <Content classes={classes} content={content} />
        ) : (
          <Avatar key={number} className={activeClass}>
            {number}
          </Avatar>
        )} */}

        {/* {current && navigationStarted ? (
          <div>
            <Button
              variant="raised"
              className={classes.button}
              onClick={callback}
            >
              Hier ben ik
            </Button>
          </div>
        ) : null} */}
        {/* {active && content ? (
          <Content classes={classes} content={content} />
        ) : null} */}
      </div>
    );
  }
}

BikeNode.propTypes = {
  classes: PropTypes.object.isRequired,
  number: PropTypes.number.isRequired,
  active: PropTypes.bool,
  current: PropTypes.bool,
  content: PropTypes.array,
  // callback: PropTypes.func.isRequired,
  navigationStarted: PropTypes.bool
};

export default withTheme()(withStyles(styles)(BikeNode));



// WEBPACK FOOTER //
// ./src/NewRoute/atoms/BikeNode.js